var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { IMaskInput } from 'react-imask';
export var MascaraVertice = React.forwardRef(function MascaraVertice(props, ref) {
    var onChange = props.onChange, other = __rest(props, ["onChange"]);
    return (_jsx(IMaskInput, __assign({}, other, { onAccept: function (rawValue) {
            var upper = (rawValue !== null && rawValue !== void 0 ? rawValue : '').toUpperCase();
            if (typeof onChange === 'function') {
                var fakeEvent = { target: { name: props.name, value: upper } };
                onChange(fakeEvent);
            }
        }, definitions: { a: /[A-Za-z]/ }, inputRef: ref, mask: "aaa-a-0000", overwrite: true })));
});
export var MascaraCoordenadaGMS = React.forwardRef(function TextMaskCustom(props, ref) {
    var onChange = props.onChange, other = __rest(props, ["onChange"]);
    return (_jsx(IMaskInput, __assign({}, other, { onAccept: function (value) { return onChange({ target: { name: props.name, value: value } }); }, definitions: {
            '#': /\d/
        }, mask: "00\u00B0 00' 00.0\\", inputRef: ref, overwrite: true })));
});
var MascaraGMS = React.forwardRef(function MascaraGMS(props, ref) {
    var onChange = props.onChange, name = props.name, allowedDirections = props.allowedDirections, other = __rest(props, ["onChange", "name", "allowedDirections"]);
    return (_jsx(IMaskInput, __assign({}, other, { onAccept: function (value) { return onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name: name, value: value } }); }, style: { textTransform: 'uppercase' }, definitions: {
            D: {
                mask: allowedDirections,
                prepare: function (value) { return value.toUpperCase(); },
            },
        }, mask: "D 00\u00B0 00' 00.000\"", inputRef: ref, overwrite: true, lazy: true })));
});
export var MascaraLatSGMS = React.forwardRef(function MascaraGMS(props, ref) {
    var onChange = props.onChange, name = props.name, allowedDirections = props.allowedDirections, other = __rest(props, ["onChange", "name", "allowedDirections"]);
    return (_jsx(IMaskInput, __assign({}, other, { onAccept: function (value) { return onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name: name, value: value } }); }, style: { textTransform: 'uppercase' }, mask: "S 00\u00B0 00' 00.000\"", defaultValue: 'S ', inputRef: ref, overwrite: true, lazy: true })));
});
export var MascaraLongOGMS = React.forwardRef(function MascaraGMS(props, ref) {
    var onChange = props.onChange, name = props.name, allowedDirections = props.allowedDirections, other = __rest(props, ["onChange", "name", "allowedDirections"]);
    return (_jsx(IMaskInput, __assign({}, other, { onAccept: function (value) { return onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name: name, value: value } }); }, style: { textTransform: 'uppercase' }, mask: "O 00\u00B0 00' 00.000\"", defaultValue: 'O ', inputRef: ref, overwrite: true, lazy: true })));
});
export var MascaraLatitudeGMS = React.forwardRef(function MascaraLatitudeGMS(props, ref) {
    return (_jsx(MascaraGMS, __assign({}, props, { ref: ref, allowedDirections: /[ns]/i })));
});
export var MascaraLongitudeGMS = React.forwardRef(function MascaraLongitudeGMS(props, ref) {
    return (_jsx(MascaraGMS, __assign({}, props, { ref: ref, allowedDirections: /[lo]/i })));
});
